var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertTriangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 124,
    viewBox: "0 0 97 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.5896 42.6011L7.35668 99.7502C6.65088 100.973 6.27742 102.358 6.27347 103.77C6.26952 105.181 6.63521 106.569 7.33415 107.795C8.0331 109.021 9.04095 110.043 10.2574 110.759C11.4739 111.475 12.8566 111.86 14.2679 111.875H82.7338C84.1451 111.86 85.5278 111.475 86.7443 110.759C87.9607 110.043 88.9686 109.021 89.6675 107.795C90.3665 106.569 90.7322 105.181 90.7282 103.77C90.7243 102.358 90.3508 100.973 89.645 99.7502L55.4121 42.6011C54.6916 41.4132 53.6771 40.4312 52.4665 39.7496C51.2559 39.068 49.8901 38.71 48.5008 38.71C47.1116 38.71 45.7458 39.068 44.5352 39.7496C43.3246 40.4312 42.3101 41.4132 41.5896 42.6011Z",
    stroke: "#FCA100",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5 63.375V79.5417",
    stroke: "#FCA100",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5 95.708H48.5404",
    stroke: "#FCA100",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertTriangle);
export default __webpack_public_path__ + "static/media/alert-triangle.83fe0f5e20f6318ed3e38a7bd563f2c1.svg";
export { ForwardRef as ReactComponent };